<template>
<div class="page">
    <div class="min-header">
        <mini-header></mini-header>
    </div>
    <div class="body">
        <div class="signup-container"> 
            <div class="signup-box">
                <el-form ref="form" :model="form" :rules="rules" @validate="formValidate">
                    <div class="inner">
                        <div class="hd">
                            <div class="title">{{ $t("lang.SignUp") }}</div>
                            <div class="description">
                                {{ $t("lang.Welcome") }}<br />
                                {{ $t("lang.Register") }}
                            </div>
                        </div>
                        <div class="bd">
                            <el-form-item class="form-item" :label="$t('lang.Referral')" >
                              <el-input v-model="form.inviteCode" :disabled="isInviteCode" :placeholder="$t('lang.referral')" />
                            </el-form-item>
                            <el-form-item class="form-item" :label="$t('lang.username')" prop="account">
                                <el-input v-model="form.account" :placeholder="$t('lang.usernamePlaceholder')" />
                            </el-form-item>
                            <el-form-item class="form-item" :label="$t('lang.email')" prop="email">
                                <el-input v-model="form.email" :placeholder="$t('lang.emailPlaceholder')" />
                                
                            </el-form-item>
                            <el-form-item class="form-item" :label="$t('lang.verifyCode')" prop="verifyCode">
                                <el-input v-model="form.verifyCode" :placeholder="$t('lang.verifyCodePlaceholder')">
                                    <template slot="append">
                                        <el-button type="primary" :loading="btnLoading" :disabled="btnIsDisabled" @click="sendCode">{{ $t('lang.sendVerifyCode') }}</el-button>
                                    </template>
                                </el-input>
                            </el-form-item>
                            <el-form-item class="form-item" :label="$t('lang.password')" prop="password">
                                <el-input v-model="form.password" show-password :placeholder="$t('lang.passwordPlaceholder')" />
                            </el-form-item>
                            <el-form-item class="form-item" :label="$t('lang.confirmPassword')" prop="checkPassword">
                                <el-input v-model="form.checkPassword" show-password :placeholder="$t('lang.confirmPasswordPlaceholder')" />
                            </el-form-item>
                            <!-- <el-form-item class="form-item">
                                <el-checkbox>I agree to the terms of service </el-checkbox>
                            </el-form-item> -->
                            <el-form-item class="form-item" style="padding-top:20px;">
                                <el-button type="primary" class="btn-login" @click="submit" :loading="submitBtnLoading">{{ $t('lang.createAccount') }}</el-button>
                            </el-form-item>
                        </div>
                        <div class="ft">
                            <div class="p">
                                {{ $t("lang.AlreadyAccount") }} <a class="link" @click="goto('/login-m')"> {{ $t("lang.Login") }}</a>
                            </div>
                        </div>
                    </div>
                </el-form>
            </div>
        </div>
    </div>
    <div class="footer">
        <Footer />
    </div>
</div>
</template>
<script>
import miniHeader from "@/components/miniHeader.vue";
import Footer from "@/components/footer.vue";
import {BASE_GLOB_API} from "@/config.js";
import {axiosGet, axiosPost} from '@/api/api';
export default {
    name:'signup',
    components: {
        miniHeader,
        Footer,
    },
    data(){
        var validatePass2 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'));
            } else if (value !== this.form.password) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        return {
            form:{
                account:'',
                email:'',
                verifyCode:'',
                password:'',
                checkPassword:'',
                inviteCode:'',
            },
            rules:{
                account:[{required:true, message:this.$t('lang.usernameRule')}],
                email:[{required:true, message:'Email is required'},{type:'email', message:'Incorrect email format'}],
                verifyCode:[{required:true, message:'Verify Code is required'}],
                password:[{required:true, message:'Password is required'}],
                checkPassword:[{required:true, message:'Confirm Password is required'}, {validator: validatePass2}],
            },
            url:{
                sendCode:BASE_GLOB_API+'/register/verifyCode/send',
                register:BASE_GLOB_API+'/register/email',
            },
            formValid:{
                account:false,
                email:false,
                verifyCode:false,
                password:false,
                checkPassword:false,
            },
            isAgree:false,
            btnLoading:false,
            submitBtnLoading:false,
            returnUrl:'',
            isInviteCode:false,
        }
    },
    computed:{
        btnIsDisabled:function(){
            let flag = false, email = this.form.email;
            if(email.length > 0 && /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/.test(email)){
                flag = true;
            }
            return !flag;
        },
    }, 
    mounted(){
        console.log("thi",this.$route.query)
        // if(this.$route.query){
        //     this.returnUrl = this.$route.query.redirect;
        // }
        if( this.$route.query.inviteCode){
            this.form.inviteCode = this.$route.query.inviteCode;
            this.isInviteCode =true;
        }
    },
    methods:{
        goto(url){
            this.$router.push({path:url})
        },
        sendCode(){
            console.log("send code");
            let params = {
                email:this.form.email
            }
            this.btnLoading = true;
            axiosGet(this.url.sendCode, params,60000).then(res=>{
                console.log("=====",res)
                if(res.success){
                    this.$message.success("验证码发送成功");
                    this.btnLoading = false;
                }
                
            })
        },
        formValidate(e,r){
            // console.log("formValidate e :",e,r)
            this.formValid[e] = r;
        },
        submit(){
            let that = this;
            this.$refs.form.validate((valid)=>{
                if(valid){
                    let params = Object.assign({}, that.form);
                    that.submitBtnLoading = true;
                    axiosPost(that.url.register, params).then(res=>{
                        if(res.success){
                            that.settingAccount(res.result);
                            that.$message.success("注册成功");
                            that.submitBtnLoading = false;
                        }else{
                            that.$message.error(res.message);
                            that.submitBtnLoading = false;
                        }
                    }).catch((err)=>{
                        that.$message.error(err);
                        that.submitBtnLoading = false;
                    })
                }
            })
        },
        settingAccount(data){
            window.sessionStorage.setItem("Token", data.token);
            window.localStorage.setItem("Token", data.token);
            window.sessionStorage.setItem('salt', data.salt);
            let userinfo = {
                id:data.id,
                account:data.account,
                nikeName:data.nikeName,
                avatar:data.headImg,
                email:data.email,
            }
            window.sessionStorage.setItem("userinfo", JSON.stringify(userinfo));
            this.$router.push({name:'account'});
            this.resultForm()
           
            // if(this.returnUrl){
            //     this.$router.push({path:this.returnUrl, query:{token:data.token}})
            // }else{
            //     this.$router.push({name:'account'});
            // }
        },
        resultForm(){
            this.form.account =''
            this.form.email =''
            this.form.verifyCode =''
            this.form.password =''
            this.form.checkPassword =''
            this.form.inviteCode =''
            this.isInviteCode =false
        }
    }
}
</script>
<style lang="less" scoped>
.page {
    background:url(~@/assets/img/login_bg.svg) no-repeat center center/2116px 2156px;
}
.signup-container {
    display:flex; justify-content: flex-end; align-items: center; width:80%; min-width:1200px; padding:120px 0; margin:0 auto;
    background:url(~@/assets/img/bg_signup.svg) no-repeat left center/500px 430px;
    .signup-box {
        width:420px;
        .inner {
            .hd {
                padding:0 0 30px;
                .title {
                    font-size:32px; font-weight:800;
                }
                .description {
                    font-size:16px; color:#999; font-weight:300;
                }
            }
            .bd {
                padding:30px; border-radius:8px; background:#fff; box-shadow:0 0 8px rgba(0,0,0,.08);
                ::v-deep .el-tabs {
                    .el-tabs__header {
                        .el-tabs__item {
                            font-size:16px; text-transform:uppercase; //font-family: 'bebas_neueregular';
                        }
                    }
                }
                .form-item {
                    margin-bottom:15px;
                    ::v-deep .el-form-item__label {
                        font-weight:600; color:#999; line-height:30px;
                    }
                    ::v-deep .el-checkbox {
                        .el-checkbox__label {
                            font-weight:normal; color:#999;
                        }
                    }
                    ::v-deep .el-input-group__append {
                        background:transparent;
                        .el-button {
                            border-radius:0 4px 4px 0; color:#fff;
                            /*&.is-disabled {
                                opacity: .6;
                            }*/
                        }
                    }
                    .btn-login {
                        display:block; width:100%;
                    }
                }
            }
            .ft {
                padding:20px 0 0; text-align:center;
                .p {
                    color:#666;
                    .link {
                        font-weight:600; color:#4458FE; cursor: pointer;
                        &:hover {
                            text-decoration: underline; opacity:.8;
                        }
                    }
                }
            }
        }
    }
}
</style>